// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"26":"font-awesome","434":"chunk-ckeditor","547":"bootstrap","881":"jquery"}[chunkId] || chunkId) + "." + {"26":"bf89617b80009e863ead","434":"66549532b57716420933","547":"111d33e91ea861c14ac5","668":"9b61c2187e335346706e","881":"fceedabe5d6edde98a63"}[chunkId] + ".js";
};